import { getCookie } from './cookie';
export const getBsi = () => {
    const win = window;
    try {
        if (win.commonConfig) {
            return win.commonConfig.bsi;
        }
        if (win.Wix) {
            return win.Wix.Utils.commonConfig.get('bsi');
        }
        return getCookie('bSession');
    }
    catch {
        return undefined;
    }
};
//# sourceMappingURL=get-bsi.js.map